import { CommonModule } from '@angular/common';
import {
    CUSTOM_ELEMENTS_SCHEMA,
    Component,
    ContentChild,
    Input,
    OnInit,
    TemplateRef,
    ViewChild
} from '@angular/core';
import { WidgetContentDirective } from '@utils/widget-content.directive';
import { ElementContext } from 'src/app/element-handling/element-context';
import { ProvideElementsDirective } from 'src/app/element-handling/provide-elements.directive';
import { ElementHostComponent } from '../element-host/element-host.component';
import { ElementHostOptions } from '../element-host/element-host.options';

@Component({
  selector: 'wct-document-host',
  standalone: true,
  imports: [CommonModule, ElementHostComponent],
  styleUrls: ['./document-host.component.scss'],
  templateUrl: './document-host.component.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [ElementContext],
  host: { '[class.loading]': 'loading()' }
})
export class DocumentHostComponent extends ProvideElementsDirective implements OnInit {
  @Input({ required: false }) public autofill: boolean = true;
  @Input({ required: false }) public autofillOptions: ElementHostOptions | undefined = undefined

  @ContentChild(WidgetContentDirective, { static: true })
  protected layoutContent: WidgetContentDirective;

  @ViewChild('elementsTemplate', { read: TemplateRef, static: true })
  protected templateElements: TemplateRef<never>;


  public ngOnInit(): void {
    if (this.autofill) {
      this.insertAutofill();
    }
  }

  private insertAutofill() {
    if (!this.layoutContent) {
      return;
    }

    this.layoutContent.viewContainerRef.createEmbeddedView(this.templateElements);
  }
}
